export default [
  {
    title: "Default Deck",
    groups: [
      {
        title: "Starting Events",
        requirements: {
          age: {
            eq: 4,
          },
        },
        slides: [
          {
            title: {
              en: "Middle Income Family",
            },
            description: {
              en: "You are born to parents of above average wealth.",
            },
            image: "/images/01-starting-events_upper-middle-family.webp",
            imageAlt: "placeholder",
            type: "event",
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  tags: {
                    add: ["middle_income", "virgin"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Wealth",
            },
            description: {
              en: "You are born to wealthy parents.",
            },
            image: "/images/01-starting-events_rich-family.webp",
            imageAlt: "placeholder",
            type: "event",
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  tags: {
                    add: ["wealthy", "virgin"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Typical Family",
            },
            description: {
              en: "You are born to parents of average wealth.",
            },
            image: "/images/01-starting-events_typical-family.webp",
            imageAlt: "placeholder",
            type: "event",
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  tags: {
                    add: ["normal", "virgin"],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Primary School ",
        requirements: {
          age: {
            gt: 5,
            lt: 14,
          },
        },
        slides: [
          {
            title: {
              en: "Water Fetching",
            },
            description: {
              en: "You are sent to fetch water for your morning chores.",
            },
            image: "/images/03-primary-school_young-girl-fetching-water.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia walking with a bucket to fetch water, surrounded by spars",
            type: "event",
            selections: [
              {
                title: {
                  en: "Hurry back home.",
                },
                effects: {
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Take a break.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: ["rested"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Time Alone",
            },
            description: {
              en: "You are left alone for a long period of time. Everyone else in your family is busy.",
            },
            image: "/images/03-primary-school_young-girl-sulking-hut.webp",
            imageAlt:
              "Black-and-white comic book style image of a young African girl around 10 years old sulking alone behind a simple thatch-roof hut",
            type: "event",
            selections: [
              {
                title: {
                  en: "Reflect or pray quietly.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Try to have fun.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: ["self_reliant"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Helping with Cooking",
            },
            description: {
              en: "You are helping your mother cook over an open fire, carefully tending to the meal.",
            },
            image: "/images/03-primary-school_young-girl-helping-cook.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia helping her mother cook over an open fire, carefully tending to the meal",
            type: "event",
            selections: [
              {
                title: {
                  en: "Ask questions about cooking.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Ask your mother how she is doing.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Caring for Animals",
            },
            description: {
              en: "You are tasked with feeding and caring for the animals.",
            },
            image: "/images/03-primary-school_young-girl-caring-animals.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia feeding chickens and goats with care",
            type: "event",
            selections: [
              {
                title: {
                  en: "Finish the task quickly.",
                },
                effects: {
                  education: -10,
                  tags: {
                    add: ["animal_care"],
                  },
                },
              },
              {
                title: {
                  en: "Seek guidance on how to care for the animals better.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["education", "veterinary_interest", "animal_lover"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning to Weave",
            },
            description: {
              en: "Your mother is weaving a basket and would like you to join her.",
            },
            image: "/images/03-primary-school_young-girl-weaving.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia seated and focused on weaving or mending a basket",
            type: "event",
            selections: [
              {
                title: {
                  en: "Give up after several mistakes.",
                },
                effects: {
                  education: -10,
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Watch closely and ask for help when stuck.",
                },
                effects: {
                  education: 10,
                  mentalHealth: 10,
                  tags: {
                    add: ["mentored", "artisan"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Practice English",
            },
            description: {
              en: "Classes are over, and you are passing time by using flashcards to learn your ABCs.",
            },
            image: "/images/03-primary-school_reading_flashcards.webp",
            imageAlt:
              "A young girl, around five years old, using flashcards to learn ABCs in a well-lit classroom.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Carefully study the flashcards, asking questions when you get stuck.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go home as soon as you can.",
                },
                effects: {
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harsh Words",
            },
            description: {
              en: "You walk into your kitchen and see your dad slap your mom. What do you do?",
            },
            image: "/images/03-primary-school_parents-fighting.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "event",
            requirements: {
              tags: {
                not: ["single_mother"],
              },
            },
            selections: [
              {
                title: {
                  en: "Walk away.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Stay and watch.",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["domestic_abuse_2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harsh Words 2",
            },
            description: {
              en: "Your dad looks at you and tells you not to be stupid like your mother.  How do you respond?",
            },
            image: "/images/03-primary-school_parents_fighting_pt2.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["domestic_abuse_2"],
                not: ["single_mother"],
              },
            },
            selections: [
              {
                title: {
                  en: "You nod and agree.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You say nothing.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -1,
                  age: -1,
                  tags: {
                    add: ["domestic_abuse_3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harsh Words 3",
            },
            description: {
              en: "Your dad walks off and you are alone with your mother. What do you do?",
            },
            image: "/images/03-primary-school_parents_fighting_pt3.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["domestic_abuse_3"],
                not: ["single_mother", "domestic_abuse_4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Nothing.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go to her.",
                },
                effects: {
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["domestic_abuse_4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harsh Words 4",
            },
            description: {
              en: "You put your hand on your mother to comfort her. She tells you men are difficult. What do you think?",
            },
            image: "/images/03-primary-school_parents_fighting_pt4.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "trigger",
            priority: 1,
            requirements: {
              tags: {
                and: ["domestic_abuse_4"],
                not: ["single_mother"],
              },
            },
            selections: [
              {
                title: {
                  en: "It's normal for men to hit women.",
                },
                effects: {
                  mentalHealth: -20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "I won't be with a man who hits me.",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Older Siblings",
            },
            description: {
              en: "Some of your oldest siblings have come to visit and share a meal. They have children around your age and younger.",
            },
            image: "/images/03-primary-school_older-siblings.webp",
            imageAlt:
              "Black-and-white comic book style image of a family eating food together.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Play with your young neices or nephews.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Ask your older siblings about their lives and what they do for work.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning to Mend",
            },
            description: {
              en: "Your mother is teaching how to mend with needle and thread.",
            },
            image: "/images/03-primary-school_learning-to-mend.webp",
            imageAlt:
              "A young girl and her mother sit outside near their home conducting a sewing lesson with needle and thread.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Ask questions about sewing techniques and other ways you practice sewing on your own.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["sewing-skills"],
                  },
                },
              },
              {
                title: {
                  en: "Only do enough to appease your mother.",
                },
                effects: {
                  education: -10,
                  tags: {
                    add: ["studious"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Family Pressure",
            },
            description: {
              en: "Your parents ask you to stay home and skip school to care for your young siblings. What do you do?",
            },
            image: "/images/03-primary-school_parents_fighting_pt4.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "You tell your parents that you don't want to miss school",
                },
                effects: {
                  education: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Agree",
                },
                effects: {
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["family-pressure-2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Family Pressure 2",
            },
            description: {
              en: "Your parents ask you multiple times to miss school to watch your siblings. You are afraid of falling behind. What do you do?",
            },
            image: "/images/03-primary-school_parents_fighting_pt4.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["family-pressure-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Talk to a trusted teacher and ask for help",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Accept the situation",
                },
                effects: {
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["family-pressure-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Family Pressure 4",
            },
            description: {
              en: " You realise you have fallen so behind in school and you think there is no point in going back. What do you do?",
            },
            image: "/images/03-primary-school_parents_fighting_pt4.png",
            imageAlt:
              "A black and white comic book style image of a young African girl sitting quietly while her parents fight, looking away with a pensive expression.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["family-pressure-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Talk to a trusted adult and ask for help.",
                },
                effects: {
                  education: 20,
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Drop out of school",
                },
                effects: {
                  education: -20,
                  mentalHealth: -20,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Late Primary School ",
        requirements: {
          age: {
            gt: 7,
            lt: 20,
          },
        },
        slides: [
          {
            title: {
              en: "First Period",
            },
            description: {
              en: "You are sitting in class and you ask your teacher to go to the toilet. In the toilet, you notice blood in your pants for the first time. What do you do?",
            },
            image: "/images/04-late-primary-school_young-girl-shocked.webp",
            imageAlt:
              "A young girl looks down in shock during a trip to the bathroom, it is implied she had gotten her first menstrual cycle.",
            type: "trigger",
            requirements: {
              age: {
                gt: 8,
                lt: 14,
              },
              tags: {
                not: ["first_period"],
              },
            },
            selections: [
              {
                title: {
                  en: "Approach a trusted  teacher for help",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: ["first_period"],
                  },
                },
              },
              {
                title: {
                  en: "Put on your pant, walk back to class and sit quietly.",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["first_period", "menarche_2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "First Period 2",
            },
            description: {
              en: "Whilst sitting on your desk, you begin to feel your pant and skirt getting wet.",
            },
            image: "/images/04-late-primary-school_menarche-2.png",
            imageAlt:
              "A young girl looks down in shock during a trip to the bathroom, it is implied she had gotten her first menstrual cycle.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["menarche_2"],
              },
            },
            selections: [
              {
                title: {
                  en: "You ask a friend or the teacher for help",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You start crying",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["menarche_3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "First Period 3",
            },
            description: {
              en: "When you stand up to leave, everyone can see the blood on your skirt and they start laughing at you. What do you do?",
            },
            image: "/images/04-late-primary-school_standing-up.png",
            imageAlt:
              "A young girl looks down in shock during a trip to the bathroom, it is implied she had gotten her first menstrual cycle.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["menarche_3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Cry even more.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You walk straight to a trusted teacher for help.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go straight home even if you have other classes or activities.",
                },
                effects: {
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Clothes",
            },
            description: {
              en: "Your newly mended clothes look even better than before as they fit perfectly.",
            },
            image: "/images/04-late-primary-school_new-clothes.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "event",
            selections: [
              {
                title: {
                  en: "Offer to mend clothes for others.",
                },
                effects: {
                  education: 10,
                  mentalHealth: 10,
                  tags: {
                    add: ["fashion-interest", "helpful"],
                  },
                },
              },
              {
                title: {
                  en: "Show off your new clothes to your friends",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Gossiping Classmates",
            },
            description: {
              en: "Some of you classmates are gossipping about inappropriate topics, they signal for you to join them.",
            },
            image: "/images/04-late-primary-school_gossip.webp",
            imageAlt:
              "Some students are gossiping in the background while our character, in the foreground, debates joining them.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Join them.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Do something else and ignore their conversation.",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Unwanted Attention",
            },
            description: {
              en: "You notice your breasts are getting bigger. A boy at school whispers about you at break. What do you do?",
            },
            image: "/images/04-late-primary-school_body-changes.png",
            imageAlt:
              "A schoolgirl looks uncomfortable while a boy nearby whispers to another student.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Ignore him.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go hide in the toilet.",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["shame", "body_changes_2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Friend Reaches Out",
            },
            description: {
              en: "Your friend finds you hiding in the toilet and asks what's wrong. What do you say?",
            },
            requirements: {
              tags: {
                and: ["body_changes_2"],
              },
            },
            image: "/images/04-late-primary-school_body-conversation.webp",
            imageAlt:
              "A concerned schoolgirl talks to her friend in a bathroom setting.",
            type: "trigger",
            selections: [
              {
                title: {
                  en: "Nothing.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: ["withdrawal"],
                  },
                },
              },
              {
                title: {
                  en: "You tell her you don't like your new breasts.",
                },
                effects: {
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["self_expression", "body_changes_3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Friend Reaches Out 2",
            },
            description: {
              en: "Your friend tells you that this is natural and you can feel proud about these changes. What do you do?",
            },
            requirements: {
              tags: {
                and: ["body_changes_3"],
              },
            },
            image: "/images/04-late-primary-school_body-conversation-2.webp",
            imageAlt:
              "A concerned schoolgirl talks to her friend in a bathroom setting.",
            type: "trigger",
            selections: [
              {
                title: {
                  en: "Ask for a sweater to hide your breasts.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go back to class.",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["withdrawal", "body_changes_4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Noticed in Class",
            },
            description: {
              en: "During class, you notice boys looking at you. What do you do?",
            },
            image: "/images/04-late-primary-school_boy-stares.webp",
            imageAlt:
              "A girl sits in a classroom, looking uncomfortable as some boys glance in her direction.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["body_changes_4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Try to make yourself small",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  tags: {
                    add: ["self_consciousness", "discomfort"],
                  },
                },
              },
              {
                title: {
                  en: "Ignore them and focus on the teacher",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["focus", "resilience"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Mother's Advice",
            },
            description: {
              en: "Your mother reminds you that you have more opportunities now than she did when she was your age. She reminds you that your ability to choose goes away if you don't use it.",
            },
            image: "/images/04-late-primary-school_motherly-advice.webp",
            imageAlt:
              "A black-and-white 90s comic book-style illustration showing a young African girl in a school uniform receiving motherly advice at home.",
            type: "event",
            requirements: {
              age: {
                eq: 12,
              },
            },
            selections: [
              {
                title: {
                  en: "Tell her you understand and are doing your best.",
                },
                effects: {
                  education: 10,
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Pretend to understand to satisfy her.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  tags: {
                    add: ["dutiful", "motherly_advice2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Girls' Club",
            },
            description: {
              en: "You've joined Girls' Club! You will meet new friends, receive homework help, and learn about how to take care yourself as a growing girl.",
            },
            image: "/images/04-late-primary-school_join-girls-club.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "trigger",
            requirements: {
              age: {
                eq: 10,
              },
              tags: {
                not: ["joined_girls_club"],
              },
            },
            selections: [
              {
                title: {
                  en: "Encourage a friend to join who is not currently in Girls' Club.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: ["joined_girls_club"],
                  },
                },
              },
              {
                title: {
                  en: "Start by asking for help with your studies.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["joined_girls_club"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide",
            },
            description: {
              en: "You are walking to school, which takes 3 hours. One day, a well-known safari guide offers you a ride. How do you respond?",
            },
            image: "/images/04-late-primary-school_safari_guide.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "event",
            requirements: {
              tags: {
                not: [
                  "exit_handsome_safari",
                  "handsome_safari_2",
                  "handsome_safari_3",
                ],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes.",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_2"],
                  },
                },
              },
              {
                title: {
                  en: "No.",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
              {
                title: {
                  en: "Maybe.",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 2",
            },
            description: {
              en: "He asks you if you want to be his girlfriend. What do you say?",
            },
            image: "/images/04-late-primary-school_handsome_safari_2.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_2"],
                not: [
                  "exit_handsome_safari",
                  "handsome_safari_3",
                  "handsome_safari_4",
                ],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes.",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_4"],
                    remove: ["handsome_safari_2"],
                  },
                },
              },
              {
                title: {
                  en: "No.",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 3",
            },
            description: {
              en: "He tells you he will give you a gift if you get in the car. What do you do?",
            },
            image:
              "/images/04-late-primary-school_handsome_safari_offers_gift.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_3"],
                not: ["exit_handsome_safari", "handsome_safari_4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_5"],
                  },
                },
              },
              {
                title: {
                  en: "No",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 4",
            },
            description: {
              en: "He puts your hand on his penis. He says that's what girlfriends do. What do you do?",
            },
            image: "/images/04-late-primary-school_handsome_safari_pt4.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_4"],
                not: ["exit_handsome_safari", "handsome_safari_5"],
              },
            },
            selections: [
              {
                title: {
                  en: "You keep your hand there.",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_6"],
                  },
                },
              },
              {
                title: {
                  en: "You ask him to stop the car and get out",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 5",
            },
            description: {
              en: "He tells you that if you want the gift, you have to give him a gift first. He puts your hand on his penis. What do you do?",
            },
            image: "/images/04-late-primary-school_handsome_safari_pt4.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_5"],
                not: [
                  "exit_handsome_safari",
                  "handsome_safari_6",
                  "handsome_safari_7",
                ],
              },
            },
            selections: [
              {
                title: {
                  en: "You keep your hand there.",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_6"],
                  },
                },
              },
              {
                title: {
                  en: "You ask him to stop the car and get out.",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 6",
            },
            description: {
              en: "When you arrive at school, he asks you if you want him to give you a ride again. What do you say?",
            },
            image: "/images/04-late-primary-school_safari_guide_6.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_6"],
                not: [
                  "exit_handsome_safari",
                  "handsome_safari_7",
                  "handsome_safari_8",
                ],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes.",
                },
                effects: {
                  physicalHealth: -20,
                  mentalHealth: -20,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_8"],
                  },
                },
              },
              {
                title: {
                  en: "No.",
                },
                effects: {
                  physicalHealth: 20,
                  mentalHealth: 20,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
              {
                title: {
                  en: "Say Nothing.",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["handsome_safari_8"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 7",
            },
            description: {
              en: "You continue walking and arrive at school. What's you next step?",
            },
            image: "/images/04-late-primary-school_safari_guide_pt5.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_7"],
                not: ["exit_handsome_safari", "handsome_safari_8"],
              },
            },
            selections: [
              {
                title: {
                  en: "You don't tell anybody what happened.",
                },
                effects: {
                  mentalHealth: -20,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
              {
                title: {
                  en: "You tell the guidance counselor what happened.",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Handsome Tour Guide 8",
            },
            description: {
              en: "All day at school, you keep thinking about what happened. You cannot focus. You think you've done something wrong. What do you do?",
            },
            image: "/images/04-late-primary-school_safari_guide_pt8.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl being asked to be a girlfriend by an older man.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["handsome_safari_8"],
                not: ["exit_handsome_safari"],
              },
            },
            selections: [
              {
                title: {
                  en: "You don't tell anybody what happened.",
                },
                effects: {
                  mentalHealth: -20,
                  tags: {
                    add: ["exit_handsome_safari"],
                  },
                },
              },
              {
                title: {
                  en: "You tell the guidance counselor what happened.",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: ["tell_counselor", "handsome_safari_exit"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Creepy Neighbour",
            },
            description: {
              en: "An adult man who is your neighbour likes passing comments about your body and he says he wishes to marry you. What do you do?",
            },
            image: "/images/04-late-primary-school_creepy-neighbor.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Smile and feel happy",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-2"],
                  },
                },
              },
              {
                title: {
                  en: "Tell him to stop",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Report to a trusted adult",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Creepy Neighbour 2",
            },
            description: {
              en: "He one day decides to touch your breasts without your consent and asks you to have sex with him. What do you do?",
            },
            image: "/images/04-late-primary-school_unwanted-touch.png",
            imageAlt:
              "Black-and-white comic book style image of a young person contemplating their feelings about intimacy.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["creepy-neighbour-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Allow it to happen",
                },
                effects: {
                  physicalHealth: -20,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-3", "unprotected-sex"],
                  },
                },
              },
              {
                title: {
                  en: "Tell him 'no!'",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Say nothing",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-4", "unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 3",
            },
            description: {
              en: "You realise you have an STI. What do you do?",
            },
            image: "/images/04-late-primary-school_nurse-office.webp",
            imageAlt: "A couple sits together discussing something important.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["creepy-neighbour-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Go to the nearest clinic for treatment.",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: ["unprotected-sex"],
                  },
                },
              },
              {
                title: {
                  en: "Share with your mentor that you need help.",
                },
                effects: {
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["unprotected_sex", "risk", "creepy-neighbour-5"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Creepy Neighbour 4",
            },
            description: {
              en: "He forces himself on you. What do you do?",
            },
            image: "/images/04-late-primary-school_creepy-neighbor-4.png",
            imageAlt: "Creepy neighbor over steps boundaries.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["creepy-neighbour-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "You scream, fight and try to get away.",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You keep it a secret.",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-6", "unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Creepy Neighbour 5",
            },
            description: {
              en: "Your mentor offers to speak with you and your parent about your options. What do you do?",
            },
            image: "/images/04-late-primary-school_mentor-involvement.png",
            imageAlt:
              "Two girls sitting on a bench, having an honest conversation.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["creepy-neighbour-5"],
              },
            },
            selections: [
              {
                title: {
                  en: "Agree to the meeting, even though you are scared",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Decide it is easier to have the baby",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Creepy Neighbour 6",
            },
            description: {
              en: "You hear that he did the same thing he did to you to another girl. What do you do?",
            },
            image: "/images/04-late-primary-school_guilt.webp",
            imageAlt: "A girl with a guilty expression.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["creepy-neighbour-6"],
              },
            },
            selections: [
              {
                title: {
                  en: "You tell your parents about what happened.",
                },
                effects: {
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-7"],
                  },
                },
              },
              {
                title: {
                  en: "You tell your freind what he did.",
                },
                effects: {
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-7"],
                  },
                },
              },
              {
                title: {
                  en: "You tell your mentor what he did.",
                },
                effects: {
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["creepy-neighbour-7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Hard Goodbye",
            },
            description: {
              en: "He gets reported to the police and they ask you to make a statement.",
            },
            image: "/images/04-late-primary-school_police-arrive.png",
            imageAlt:
              "A teen girl looks conflicted while her boyfriend looks confused.",
            type: "event",
            requirements: {
              tags: {
                and: ["creepy-neighbour-7"],
              },
            },
            selections: [
              {
                title: {
                  en: "You agree and tell them what happened to you",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You are scared and refuse to speak",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family",
            },
            description: {
              en: "One night while your aunty is away, your uncle calls you to his bedroom and asks you to scratch his back.",
            },
            image: "/images/04-late-primary-school_family-boundaries.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Continue.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 10",
            },
            description: {
              en: "You uncle rapes you two more times when there is no one at home. You are so hurt that you cannot focus on anything and you fail out of school.  What do you do?",
            },
            image: "/images/04-late-primary-school_trusted-adults.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt10"],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel sad and scared all the time but you are afraid to tell someone.",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -30,
                  tags: {
                    add: ["groomed-by-uncle-end"],
                  },
                },
              },
              {
                title: {
                  en: "You decide to talk to an adult you trust about what is happenening to you.",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 30,
                  tags: {
                    add: ["groomed-by-uncle-end"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 2",
            },
            description: {
              en: "He tells you: This is my house, you must do what I say.",
            },
            image: "/images/04-late-primary-school_family-boundaries-2.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt3"],
                    remove: ["groomed-by-uncle-pt2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 3",
            },
            description: {
              en: "While you are scratching his back, he grabs your hand and tells you that you need to be a good girl and pay him back for taking care of you",
            },
            image: "/images/04-late-primary-school_family-boundaries-3.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 4",
            },
            description: {
              en: "He tells you that you are now a big girl, and reaches his hand in your dress to touch your thighs and bum.",
            },
            image: "/images/04-late-primary-school_family-boundaries-4.png",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt4"],
              },
            },
            selections: [
              {
                title: {
                  en: "You somehow are able to get away.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt5"],
                    remove: ["groomed-by-uncle-pt4"],
                  },
                },
              },
              {
                title: {
                  en: "You are not able to get away.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt5"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 5",
            },
            description: {
              en: "Two days later your aunty is back home. It's just the two of you at home. You have been feeling bad about what your uncle did. Since he did not have sex with you, you are not sure what to do.",
            },
            image: "/images/04-late-primary-school_family-boundaries-pt5.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt5"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell your aunty what happened",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt6"],
                  },
                },
              },
              {
                title: {
                  en: "Don’t tell her what happened",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt7"],
                  },
                },
              },
              {
                title: {
                  en: "Tell a teacher at school or your mentor",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt9"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 6",
            },
            description: {
              en: "You tell your aunty what happened. She shouts at you and tells you it's all your fault. She says you must never speak about it again and never tell anyone else or she will send you away",
            },
            image: "/images/04-late-primary-school_family-boundaries-4.png",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt6"],
              },
            },
            selections: [
              {
                title: {
                  en: "You don’t  tell  any one else",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt7"],
                  },
                },
              },
              {
                title: {
                  en: "You tell your mentor/a teacher",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt9"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 7",
            },
            description: {
              en: "It's three weeks later and again you are home alone with your uncle. This time, he forces himself on you and rapes you.",
            },
            image: "/images/04-late-primary-school_family-boundaries-4.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt7"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell your aunty what happened",
                },
                effects: {
                  mentalHealth: 30,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt8", "unprotected-sex"],
                  },
                },
              },
              {
                title: {
                  en: "Tell an adult you trust",
                },
                effects: {
                  mentalHealth: 30,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt8", "unprotected-sex"],
                  },
                },
              },
              {
                title: {
                  en: "Tell no one",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt10", "unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 8",
            },
            description: {
              en: "Your uncle is arrested, and the police ask you what happened. They tell you this is not your fault and nothing bad will happen to you if you tell the truth. You remember on your way to the police station some of your family members begged you to lie because if your uncle is arrested, the family will have no income. What do you do?",
            },
            image: "/images/04-late-primary-school_police-arrive.png",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt8"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell the truth",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 30,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt9"],
                  },
                },
              },
              {
                title: {
                  en: "Tell the police nothing happened",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -30,
                  age: -1,
                  tags: {
                    add: ["groomed-by-uncle-pt10"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Standing Up to Family 9",
            },
            description: {
              en: "You go and stay somewhere safe. A counsellor helps you talk through your trauma. Your mentor, teachers and everyone helps give you all the support you need. They tell you it's not your fault and that your uncle had no right to rape you. Nobody has the right to touch you without your consent. How do you feel?",
            },
            image: "/images/04-late-primary-school_family-boundaries-9.webp",
            imageAlt:
              "Black-and-white comic book style image of a student feeling unsure in a situation at home.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["groomed-by-uncle-pt9"],
                not: ["groomed-by-uncle-end"],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel better because you have someone to talk to.",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 10,
                  tags: {
                    add: ["groomed-by-uncle-end"],
                  },
                },
              },
              {
                title: {
                  en: "You are sad because you still think the situation is your fault.",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -10,
                  tags: {
                    add: ["groomed-by-uncle-end"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harassed by Group",
            },
            description: {
              en: "You have been harassed at school by boys and a male teacher. They follow you after school, and they have even scared you on several occasions by asking if they can date you. What do you do?",
            },
            image: "/images/04-late-primary-school_inappropriate-comments.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel unsafe and reluctant to attend school and do nothing",
                },
                effects: {
                  mentalHealth: -20,
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["harassed-2"],
                  },
                },
              },
              {
                title: {
                  en: "You report this to a trusted teacher or your mentor",
                },
                effects: {
                  education: 20,
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["harassed-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harassed by Group 2",
            },
            description: {
              en: "You now feel scared to come to school. What do you do?",
            },
            image: "/images/04-late-primary-school_scared-to-go-to-school.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["harassed-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Drop out of school",
                },
                effects: {
                  education: -40,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Reduce in attendance",
                },
                effects: {
                  education: -30,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Force yourself to go, even if you feel scared",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Harassed by Group 3",
            },
            description: {
              en: "They finally stop bothering you. What do you think can happen now?",
            },
            image: "/images/04-late-primary-school_back-to-normal.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["harassed-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel safer at school",
                },
                effects: {
                  education: 40,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Your grades improve",
                },
                effects: {
                  education: 30,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You help other girls who feel harassed",
                },
                effects: {
                  education: 20,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis",
            },
            description: {
              en: "You have been feeling sick for months. After a clinic visit with your parents, you learn that you have HIV. You barely understand what that means. How do you feel?",
            },
            image: "/images/04-late-primary-school_hiv-diagnosis.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "event",
            requirements: {
              tags: {
                and: ["unprotected-sex"],
              },
            },
            selections: [
              {
                title: {
                  en: "You are afraid, confused and need to understand more.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["hiv-2"],
                  },
                },
              },
              {
                title: {
                  en: "You refuse to believe this has happened to you.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["hiv-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis 2",
            },
            description: {
              en: "You speak to a nurse. The nurse explains to you what HIV is but uses difficult words and you do not understand. What do you do?",
            },
            image: "/images/04-late-primary-school_hiv-diagnosis-2.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["hiv-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "You sort of understand the information and decide to join a youth friendly corner for support from your peers.",
                },
                effects: {
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["hiv-5"],
                  },
                },
              },
              {
                title: {
                  en: "Tell the nurse you don't understand and ask her to explain it again, with words you can understand.",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["hiv-4"],
                  },
                },
              },
              {
                title: {
                  en: "You feel so overwhelmed and you shut down.",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["hiv-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis 3",
            },
            description: {
              en: "Back in your village and school, you hear whispers and see fearful looks. Someone saw you at the clinic and rumours are spreading about a disease. How do you react?",
            },
            image: "/images/04-late-primary-school_hiv-diagnosis-3.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["hiv-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Isolate yourself out of shame.",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  education: -20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Try to Ignore the rumors and continue your daily life by taking care of yourself.",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  education: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Seek advice from an adult whom you trust.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis 4",
            },
            description: {
              en: "You stay in a place that is very far from clinics or hospitals. Getting your antiretroviral medication (ARVs) means you have to walk a long journey each month. How do you manage?",
            },
            image: "/images/04-late-primary-school_long-walk.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["hiv-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Rely on family support and assistance to make the journey",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Consider stopping treatment due to the difficulty",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  education: -20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Contact the clinic and seek help for other options",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["hiv-6"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis 5",
            },
            description: {
              en: "At the  youth-friendly corner, you find others facing similar problems due to distance and stigma. They discuss traditional remedies and beliefs about HIV in your community. What do you do?",
            },
            image: "/images/04-late-primary-school_people-noticing.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["hiv-5"],
              },
            },
            selections: [
              {
                title: {
                  en: "Share your own experiences and seek advice on dealing with local beliefs",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Keep your thoughts to yourself.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Offer practical solutions you have found to cope with the challenges.",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Receiving an HIV Diagnosis 6",
            },
            description: {
              en: "After speaking with the nurse in simpler terms, she connects you with a community health worker who can visit you at home. The worker explains the importance of taking your medication correctly. How do you respond?",
            },
            image: "/images/04-late-primary-school_hiv-education.webp",
            imageAlt:
              "Black-and-white comic book style image of a young person sitting in a clinic, learning about their diagnosis.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["hiv-6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Decide to follow the health worker's advice.",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Express doubt about the medication because you want to try traditional solutions.",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School",
            },
            description: {
              en: "An older boy from your school tells you that you have a nice bum in the presence of other pupils. What do you do?",
            },
            image: "/images/04-late-primary-school_inappropriate-comments.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "event",
            selections: [
              {
                title: {
                  en: "You smile and say thank you",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_2"],
                  },
                },
              },
              {
                title: {
                  en: "You ignore him",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 2",
            },
            description: {
              en: "When leaving  school, he touches your bum and winks at you. What do you do?",
            },
            image: "/images/04-late-primary-school_after-school.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_2"],
              },
            },
            selections: [
              {
                title: {
                  en: "You smile",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_3"],
                  },
                },
              },
              {
                title: {
                  en: "You tell him to stop",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 3",
            },
            description: {
              en: "He asks you to meet him in an unfinished building after school.",
            },
            image: "/images/04-late-primary-school_meet-him.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_3"],
              },
            },
            selections: [
              {
                title: {
                  en: "You say yes",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_4"],
                  },
                },
              },
              {
                title: {
                  en: "You say no",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 4",
            },
            description: {
              en: "He pulls you close and tries to kiss you. What do you do?",
            },
            image: "/images/04-late-primary-school_meet-him-2.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_4"],
              },
            },
            selections: [
              {
                title: {
                  en: "You let him kiss you",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_5"],
                  },
                },
              },
              {
                title: {
                  en: "You run out of the building",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 5",
            },
            description: {
              en: "You like how it feels when he touches you. You want him to touch you again. What happens next?",
            },
            image: "/images/04-late-primary-school_inappropriate-comments.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_5"],
              },
            },
            selections: [
              {
                title: {
                  en: "You let him put his hand under your skirt",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_6"],
                  },
                },
              },
              {
                title: {
                  en: "You feel afraid of your feelings and run away. ",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 6",
            },
            description: {
              en: "You like how it feels. He asks you if you want to have sex. You aren't sure. What do you do?",
            },
            image: "/images/04-late-primary-school_trust_too_quickly.PNG",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell him you want to wait until you feel sure ",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Tell him yes, but he needs to wear a condom.",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Say yes even though you are not sure",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["inappropriate_comments_7", "unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Inappropriate Comments at School 7",
            },
            description: {
              en: "He tells you he doesn't have a condom. What do you do?",
            },
            image: "/images/04-late-primary-school_no-condom-question.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["inappropriate_comments_7"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell him no",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Tell him yes",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  tags: {
                    add: ["unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend",
            },
            description: {
              en: "You and a boy in your class started dating in Grade 10. You held hands and kissed for the first six months. He was your first kiss. You think you love him. ",
            },
            image: "/images/04-late-primary-school_new-boyfriend.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "event",
            selections: [
              {
                title: {
                  en: "Continue.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["new-boyfriend-2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 2",
            },
            description: {
              en: "After six months, you want him to touch your breasts when kissing. You ask him to do this and he wants to know if you are sure. What do you say?",
            },
            image: "/images/04-late-primary-school_bra.png",
            imageAlt:
              "Black-and-white comic book style image of a young person contemplating their feelings about intimacy.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes you are sure",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: [
                      "possible-pregancy",
                      "hiv-exposure",
                      "new-boyfriend-3",
                      "unprotected-sex",
                    ],
                  },
                },
              },
              {
                title: {
                  en: "No you are not sure",
                },
                effects: {
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["new-boyfriend-4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 3",
            },
            description: {
              en: "He starts touching your breasts and you love the way it feels. After a few more months, you want to have sex but you feel bad for wanting to have sex. What do you do?",
            },
            image: "/images/04-late-primary-school_feeling-bad.png",
            imageAlt: "A couple sits together discussing something important.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell him you want to have sex",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [
                      "protection",
                      "responsibility",
                      "new-boyfriend-5",
                      "unprotected-sex",
                    ],
                  },
                },
              },
              {
                title: {
                  en: "Keep quiet",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["unprotected_sex", "risk", "new-boyfriend-6"],
                  },
                },
              },
              {
                title: {
                  en: "Pray to God to make the feeling stop",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["new-boyfriend-6"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 3 Redux",
            },
            description: {
              en: "He starts touching your breasts and you love the way it feels. After a few more months, you want to have sex but you feel bad for wanting to have sex. What do you do?",
            },
            image: "/images/04-late-primary-school_desire.webp",
            imageAlt: "A couple sits together discussing something important.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-3-r"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell him you want to have sex",
                },
                effects: {
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: [
                      "protection",
                      "responsibility",
                      "new-boyfriend-5-r",
                      "unprotected-sex",
                    ],
                  },
                },
              },
              {
                title: {
                  en: "Keep quiet",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["unprotected_sex", "risk", "new-boyfriend-6-r"],
                  },
                },
              },
              {
                title: {
                  en: "Pray to God to make the feeling stopß",
                },
                effects: {
                  mentalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["suppressed_desire", "confusion, new-boyfriend-6-r"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 4",
            },
            description: {
              en: "Your boyfriend listens to you. You trust him. After a few more months, you decide you want him to touch your breasts again and you ask him to have sex. This time you are sure.",
            },
            image: "/images/04-late-primary-school_you-are-sure.png",
            imageAlt:
              "Two teenagers talking warmly and respectfully in a private moment.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["trust", "clarity", "new", "new-boyfriend-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 5",
            },
            description: {
              en: "You tell your boyfriend you want to have sex. He says he also wants to. What happens next?",
            },
            image: "/images/04-late-primary-school_desire.webp",
            imageAlt: "A couple sits together discussing something important.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-5"],
              },
            },
            selections: [
              {
                title: {
                  en: "You get condoms",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 120,
                  age: -1,
                  tags: {
                    add: ["protection", "responsibility", "new-boyfriend-3-r"],
                  },
                },
              },
              {
                title: {
                  en: "You have sex without a condom.",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -20,
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["unprotected_sex", "risk", "creepy-neighbour-3"],
                  },
                },
              },
              {
                title: {
                  en: "You do nothing and hope the feeling goes away",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["suppressed_desire", "confusion", "new-boyfriend-6"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 5 redux",
            },
            description: {
              en: "You tell your boyfriend you want to have sex. He says he also wants to. What happens next?",
            },
            image: "/images/04-late-primary-school_mixed-feelings.png",
            imageAlt: "A couple sits together discussing something important.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-5-r"],
              },
            },
            selections: [
              {
                title: {
                  en: "You continue having protected sex",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["protection", "responsibility", "new-boyfriend-6-r"],
                  },
                },
              },
              {
                title: {
                  en: "You sleep with him without a condom",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -20,
                  education: -20,
                  tags: {
                    add: ["unprotected_sex", "risk"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 6",
            },
            description: {
              en: "All you can think about is sex. You talk to a friend and she says these feelings are normal. Do you feel better?",
            },
            image: "/images/04-late-primary-school_talked-to-friend.png",
            imageAlt:
              "Two girls sitting on a bench, having an honest conversation.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes",
                },
                effects: {
                  mentalHealth: 20,
                  education: 20,
                  age: -1,
                  tags: {
                    add: ["normalization", "support", "new-boyfriend-5"],
                  },
                },
              },
              {
                title: {
                  en: "No",
                },
                effects: {
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["shame", "self_doubt", "new-boyfriend-7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "New Boyfriend 6 Redux",
            },
            description: {
              en: "All you can think about is sex. You talk to a friend and she says these feelings are normal. Do you feel better?",
            },
            image: "/images/04-late-primary-school_talked-to-friend.png",
            imageAlt:
              "Two girls sitting on a bench, having an honest conversation.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["new-boyfriend-6-r"],
              },
            },
            selections: [
              {
                title: {
                  en: "Yes",
                },
                effects: {
                  mentalHealth: 20,
                  education: 20,
                  tags: {
                    add: ["normalization", "support"],
                  },
                },
              },
              {
                title: {
                  en: "No",
                },
                effects: {
                  education: -20,
                  age: -1,
                  tags: {
                    add: ["shame", "self_doubt", "new-boyfriend-7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Hard Goodbye",
            },
            description: {
              en: "You feel guilty. You break up with your boyfriend. He doesn't understand what he did wrong. You feel sad. What do you tell him?",
            },
            image: "/images/04-late-primary-school_guilty-break-up.png",
            imageAlt:
              "A teen girl looks conflicted while her boyfriend looks confused.",
            type: "event",
            requirements: {
              tags: {
                and: ["new-boyfriend-7"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell the truth — you want to have sex but feel bad about it",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: ["honesty", "emotional_intelligence"],
                  },
                },
              },
              {
                title: {
                  en: "Lie because it's too hard to talk about",
                },
                effects: {
                  mentalHealth: -20,
                  tags: {
                    add: ["avoidance", "emotional_pain"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Unwanted Touch in Class",
            },
            description: {
              en: "You are in class, sitting next to a boy. You notice he puts his hand on your thigh. What do you do?",
            },
            image: "/images/04-late-primary-school_unwanted-touch.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Report him to your teacher",
                },
                effects: {
                  mentalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Look at him and smile",
                },
                effects: {
                  education: -10,
                  mentalHealth: -1,
                  tags: {
                    add: ["unwanted-touch-2"],
                  },
                },
              },
              {
                title: {
                  en: "Say nothing",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: ["unwanted-touch-2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Unwanted Touch in Class 2",
            },
            description: {
              en: "He continues touching you and signals that he wants to meet you after class. What do you do?",
            },
            image: "/images/04-late-primary-school_unwanted-touch.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["unwanted-touch-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Ignore Him",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You agree to meet him",
                },
                effects: {
                  tags: {
                    add: ["unwanted-touch-3"],
                  },
                },
              },
              {
                title: {
                  en: "You tell a teacher",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Unwanted Touch in Class 3",
            },
            description: {
              en: "When you meet up with him,, he tries to force himself on you.",
            },
            image: "/images/04-late-primary-school_unwanted-force.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["unwanted-touch-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Push him away and run",
                },
                effects: {
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You feel helpless and do nothing",
                },
                effects: {
                  physicalHealth: -10,
                  tags: {
                    add: ["unwanted-touch-4", "unprotected-sex"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Unwanted Touch in Class 4",
            },
            description: {
              en: "A few months later,  you feel sick so you go to the clinic and they test you for HIV. You are positive. What do you do?",
            },
            image: "/images/04-late-primary-school_at-clinic.PNG",
            imageAlt:
              "Black-and-white comic book style image of a young girl noticing an inappropriate touch from a classmate.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["unwanted-touch-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Pretend you don't have HIV and say nothing",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -10,
                  education: -10,
                  tags: {
                    add: ["hiv-positive"],
                  },
                },
              },
              {
                title: {
                  en: "Tell your parents what happened and ask for help",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["hiv-positive"],
                  },
                },
              },
              {
                title: {
                  en: "Tell your mentor you need help",
                },
                effects: {
                  mentalHealth: 20,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["hiv-positive"],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Early Highschool ",
        requirements: {
          age: {
            gt: 14,
            lt: 18,
          },
        },
        slides: [],
      },
      {
        title: "High School ",
        requirements: {
          age: {
            gt: 13,
            lt: 24,
          },
        },
        slides: [
          {
            title: {
              en: "Tearful Friend",
            },
            description: {
              en: "One of your friends is crying. You go to comfort her. She tells you she is upset because she could be pregnant, and she doesn't know what to do.",
            },
            image: "/images/06-highschool_pregnant-friend.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Ask her how she could let this happen? Remind her that the consequences will be dire.",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Comfort her and tell her there are ways to get help. Encourage her to talk with the school medical staff or a trusted female counselor.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chess Club",
            },
            description: {
              en: "You have an opportunity to start a Chess Club with your fellow classmates.",
            },
            image: "/images/06-highschool_chess-club.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Join the new Chess Club.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["chess-interest"],
                  },
                },
              },
              {
                title: {
                  en: "Do other chores",
                },
                effects: {
                  tags: {
                    add: ["dutiful"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Poetry Club",
            },
            description: {
              en: "A group students who enjoy creative writing are discussing creating a Poetry Club.",
            },
            image: "/images/06-highschool_poetry-club.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Join the new poetry club.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["poetry_club"],
                  },
                },
              },
              {
                title: {
                  en: "Decline and focus on more important things.",
                },
                effects: {
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Sports Training",
            },
            description: {
              en: "A Physical Education teacher has noticed your skills in sport, and encourages you to join a competitive team.",
            },
            image: "/images/06-highschool_sports-training.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl in rural Zambia drying clothes by hanging them on a simple line",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Join the competitive team and recieve more training.",
                },
                effects: {
                  education: 10,
                  physicalHealth: 10,
                  tags: {
                    add: ["sports_training"],
                  },
                },
              },
              {
                title: {
                  en: "Thank the teacher for the compliment but decline the offer.",
                },
                effects: {
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Visit to the School Chapel",
            },
            description: {
              en: "You are visiting the school chapel today.",
            },
            image: "/images/06-highschool_school_chapel.webp",
            imageAlt:
              "A black and white comic book-style illustration of the school chapel at Katete All Girls Boarding School in Zambia. The chapel is a modest brick building.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Pray for your family and important people in your life.",
                },
                effects: {
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Seek guidance.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali",
            },
            description: {
              en: "You have just been through your initiation ceremony, and your traditional counsellor taught you how to please a man in bed. You notice that ever since you 'came out of the house', older boys and men want to talk to you and look at you differently.",
            },
            image: "/images/06-highschool_chinamwali-1.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "event",
            requirements: {
              age: {
                gt: 14,
                lt: 16,
              },
              tags: {
                and: ["first-period"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["chinamwali-2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali 2",
            },
            description: {
              en: "One day, your 20 year old neighbour tells you he will give you money if you can show him what they taught you 'in the house'.",
            },
            image: "/images/06-highschool_inappropriate-comment.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["chinamwali-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "You agree",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  age: -1,
                  tags: {
                    add: ["chinamwali-3"],
                  },
                },
              },
              {
                title: {
                  en: "You say no",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["chinamwali-4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali 3",
            },
            description: {
              en: "A few weeks later, a friend to the boy says he heard that you are a real woman, and he wants to have sex with you. He says that if you agree, he will buy you a new dress. How do you respond?",
            },
            image: "/images/06-highschool_inappropriate.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["chinamwali-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Say no",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["chinamwali-4"],
                  },
                },
              },
              {
                title: {
                  en: "Say yes",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["chinamwali-4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali 4",
            },
            description: {
              en: "One day, your friends tell you that their grandmothers told them that you need to keep having sex while young because it means you will have babies easily when you are older. What do you do?",
            },
            image: "/images/06-highschool_inappropriate-comments.webp",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["chinamwali-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Find boys to have sex with",
                },
                effects: {
                  physicalHealth: -30,
                  age: -1,
                  tags: {
                    add: ["chinamwali-5"],
                  },
                },
              },
              {
                title: {
                  en: "Ask your mentor/teacher whether this is true",
                },
                effects: {
                  physicalHealth: 30,
                  age: -1,
                  tags: {
                    add: ["chinamwali-6"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali 5",
            },
            description: {
              en: "While walking in the village, you hear a group of boys talking about how they have 'tasted' you. One calls out to offer you money if he can also have sex with you. How do you respond?",
            },
            image: "/images/06-highschool_inappropriate-comments2.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["chinamwali-5"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell the boy to go away",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You stay quiet",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You agree",
                },
                effects: {
                  mentalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Chinamwali 6",
            },
            description: {
              en: "Your Mentor tells you that it is not true. She tells you that sex is not meant to just please men but that it can be an enjoyable experience for both females and males when you are ready. What do you do with this information?",
            },
            image: "/images/06-highschool_mentor-truth.png",
            imageAlt:
              "Black-and-white comic book style image of a student receiving a comment from an older peer.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["chinamwali-6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Accept the new information that you mentor has given you",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Do not accept what your the mentor has just told you and keep believing your counsellor and friends",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -30,
                  education: -30,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Ask your mentor more questions so that you understand better",
                },
                effects: {
                  mentalHealth: 30,
                  physicalHealth: 30,
                  education: 30,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives",
            },
            description: {
              en: "You pass your grade seven exam and go to a good boarding school. You make friends with several girls coming from the big city.",
            },
            image: "/images/06-highschool_good-boarding-school.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["contraceptives-2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 10",
            },
            description: {
              en: "Your boyfriend says that is not fair, and if you love him you will accept that he doesn't wear condoms. He says if you can't accept this, the relationship will be over. What do you?",
            },
            image: "/images/06-highschool_contraceptives-discussion10.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-10"],
              },
            },
            selections: [
              {
                title: {
                  en: "Tell him the relationship is over",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Agree to continue having sex without protection",
                },
                effects: {
                  physicalHealth: -10,
                  mentalHealth: -10,
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 2",
            },
            description: {
              en: "One day, your friends are talking about how they've all had sex with their boyfriends and won't get pregnant because they use contraception.",
            },
            image: "/images/06-highschool_contraceptives-discussion2.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-2"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue.",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["contraceptives-3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 3",
            },
            description: {
              en: "You have been having sex with your boyfriend but not using contraception. Luckily, you haven’t gotten pregnant, but you are scared you might. What do you do?",
            },
            image: "/images/06-highschool_contraceptives-discussion3.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-3"],
              },
            },
            selections: [
              {
                title: {
                  en: "Approach a trusted adult during the holiday to explain the situation and ask for help",
                },
                effects: {
                  physicalHealth: 10,
                  education: 10,
                  mentalHealth: 10,
                  age: -1,
                  tags: {
                    add: ["contraceptives-4"],
                  },
                },
              },
              {
                title: {
                  en: "Continue having unprotected sex",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -30,
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Ask your boyfriend to get protection",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["contraceptives-8"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 4",
            },
            description: {
              en: "You have been told to visit the clinic for you to get right information about contraceptives, what they do and how to use them. What do you do?",
            },
            image: "/images/06-highschool_contraceptives-discussion.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-4"],
              },
            },
            selections: [
              {
                title: {
                  en: "Nothing - you feel shy to go to the clinic",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -20,
                  education: -20,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Go to the clinic to ask for help",
                },
                effects: {
                  physicalHealth: 20,
                  education: 20,
                  mentalHealth: 20,
                  age: -1,
                  tags: {
                    add: ["contraceptives-5"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 5",
            },
            description: {
              en: "You reach the clinic and you find the place so busy. What do you do?",
            },
            image: "/images/06-highschool_contraceptives-discussion5.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-5"],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel nervous and leave",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Ask a nurse how to be seen",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["contraceptives-6"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 6",
            },
            description: {
              en: "You are escorted to a youth friendly corner. When you get there, you find a group of adolescents like you in a room with charts on the wall showing the reproductive systems for both boys and girls. A nurse welcomes you and asks you to feel free to interact with your peers.  ",
            },
            image: "/images/06-highschool_contraceptives-discussion6.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Continue",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: ["contraceptives-7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 7",
            },
            description: {
              en: "The nurse explains how pregnancy occurs and what measures you can take to prevent unwanted pregnancy. She further explains what contraceptives are, the types and how to use them. She asks everyone to think about what contraceptive they want to use. What do you say? ",
            },
            image: "/images/06-highschool_contraceptives-discussion7.png",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-7"],
              },
            },
            selections: [
              {
                title: {
                  en: "You leave because you aren't sure what to choose",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You ask to speak to the nurse privately for more information",
                },
                effects: {
                  physicalHealth: 10,
                  education: 10,
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You choose condoms and birth control injection to be extra safe",
                },
                effects: {
                  physicalHealth: 10,
                  education: 10,
                  mentalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 8",
            },
            description: {
              en: "Your boyfriend says sex doesn't feel good with a condom. How do you respond?",
            },
            image: "/images/06-highschool_contraceptives-discussion.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-8"],
              },
            },
            selections: [
              {
                title: {
                  en: "You say nothing",
                },
                effects: {
                  mentalHealth: -20,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["contraceptives-9"],
                  },
                },
              },
              {
                title: {
                  en: "You tell him if he loves you, he will wear a condom",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["contraceptives-10"],
                  },
                },
              },
              {
                title: {
                  en: "You tell him there won't be any more sex without protection",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Learning About Contraceptives 9",
            },
            description: {
              en: "You and your boyfriend are about to have sex again and there is no condom. What can you do?",
            },
            image: "/images/06-highschool_contraceptives-discussion9.webp",
            imageAlt:
              "Black-and-white comic book style image of a young girl discussing contraception options with friends.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["contraceptives-9"],
              },
            },
            selections: [
              {
                title: {
                  en: "Have sex and risk getting pregnant",
                },
                effects: {
                  mentalHealth: -30,
                  physicalHealth: -30,
                  education: -30,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Tell him from now on you will only have sex with condoms",
                },
                effects: {
                  physicalHealth: 10,
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Peer Pressure to Skip School",
            },
            description: {
              en: "One Friday at school, some popular girls in your class tell you to miss school and go with them to a party. What do you do?",
            },
            image: "/images/06-highschool_peer-pressure-party.webp",
            imageAlt:
              "Black-and-white comic book style image of a student being invited to skip school by classmates.",
            type: "event",
            requirements: {
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "You say no.",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You say yes.",
                },
                effects: {
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_2"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party",
            },
            description: {
              en: "You discover that the 'party' is in the bush, and everyone is smoking and drinking. A boy you like tells you that you are beautiful and asks you to smoke. What do you do?",
            },
            image: "/images/06-highschool_risky-party.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_2"],
              },
            },
            selections: [
              {
                title: {
                  en: "You say no and leave.",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["left-party"],
                  },
                },
              },
              {
                title: {
                  en: "You say no to smoking, but decide to stay.",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_3"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 3",
            },
            description: {
              en: "Its Girls Club on Monday and your mentor asks you why you were not in school on Friday. How do you respond?",
            },
            image: "/images/06-highschool_people-noticing.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_3"],
              },
            },
            selections: [
              {
                title: {
                  en: "You tell the truth.",
                },
                effects: {
                  mentalHealth: 10,
                  physicalHealth: 10,
                  education: 10,
                  tags: {
                    add: ["left-party"],
                  },
                },
              },
              {
                title: {
                  en: "You tell the mentor that you were ill.",
                },
                effects: {
                  mentalHealth: -10,
                  physicalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_4"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 4",
            },
            description: {
              en: "It’s now Monday and the popular girls tell you to skip school and go with them to Market day. They tell you the boy you like will also be there. What do you do?",
            },
            image: "/images/06-highschool_risky-party.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_4"],
              },
            },
            selections: [
              {
                title: {
                  en: "You say no",
                },
                effects: {
                  education: 10,
                  tags: {
                    add: ["left-party"],
                  },
                },
              },
              {
                title: {
                  en: "You say yes",
                },
                effects: {
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_5"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 5",
            },
            description: {
              en: "After a few days of hanging out with your friends, you notice that you cannot focus in class and your grades are dropping. What do you do?",
            },
            image: "/images/06-highschool_dropping-grades.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_5"],
              },
            },
            selections: [
              {
                title: {
                  en: "Seek help from your mentor",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["party_6"],
                  },
                },
              },
              {
                title: {
                  en: "Keep quiet",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_7"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 6",
            },
            description: {
              en: "Your mentor advises you to stop hanging out with your new friends and focus on school. What do you do?",
            },
            image: "/images/06-highschool_trusted-adults.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_6"],
              },
            },
            selections: [
              {
                title: {
                  en: "Listen to your mentor",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  age: -1,
                  tags: {
                    add: ["party_7"],
                  },
                },
              },
              {
                title: {
                  en: "Ignore the mentor",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  age: -1,
                  tags: {
                    add: ["party_8"],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 7",
            },
            description: {
              en: "Your grades start improving and you pass your Grade 7 exams and proceed  to Grade 8. The popular girls and the boy don't want to spend time with you anymore. How  do you feel?",
            },
            image: "/images/06-highschool_girls_club.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_7"],
              },
            },
            selections: [
              {
                title: {
                  en: "You feel happy.",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  physicalHealth: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "You feel sad.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  physicalHealth: -10,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "A Risky Party 8",
            },
            description: {
              en: "You fail your Grade 7 exams and have to repeat two years of primary school. What do you do?",
            },
            image: "/images/06-highschool_failing-grade.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            requirements: {
              tags: {
                and: ["party_8"],
              },
            },
            selections: [
              {
                title: {
                  en: "You agree to repeat.",
                },
                effects: {
                  mentalHealth: 10,
                  education: 10,
                  tags: {
                    add: [],
                  },
                },
              },
              {
                title: {
                  en: "Decide to drop out of school.",
                },
                effects: {
                  mentalHealth: -10,
                  education: -10,
                  tags: {
                    add: ["dropped_out_of_school"],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        title: "Late Highschool",
        requirements: {
          age: {
            gt: 16,
            lt: 19,
          },
        },
        slides: [],
      },
      {
        title: "Early Adulthood",
        requirements: {
          age: {
            gt: 19,
            lt: 24,
          },
        },
        slides: [],
      },
      {
        title: "Adulthood ",
        requirements: {
          age: {
            gt: 18,
            lt: 27,
          },
        },
        slides: [],
      },
      {
        title: "End Game ",
        requirements: {
          age: {
            gt: 24,
          },
        },
        slides: [],
      },
      {
        title: "System",
        requirements: {},
        slides: [
          {
            title: {
              en: "Low Education",
            },
            description: {
              en: "Your education meter has reached zero. Please raise your hand and ask for help.",
            },
            image: "/images/system-slides_failing-grade.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            priority: 2,
            requirements: {
              education: {
                lt: 1,
              },
              age: {
                gt: 2,
              },
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "I've received help. ",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Low Mental",
            },
            description: {
              en: "Your mental health meter has reached zero. Please raise your hand and ask for help.",
            },
            image: "/images/system-slides_failing-grade.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            priority: 2,
            requirements: {
              mentalHealth: {
                lt: 1,
              },
              age: {
                gt: 2,
              },
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "I've received help. ",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
          {
            title: {
              en: "Low Physical",
            },
            description: {
              en: "Your physical health meter has reached zero. Please raise your hand and ask for help. ",
            },
            image: "/images/system-slides_failing-grade.webp",
            imageAlt:
              "Black-and-white comic book style image of a party in an unsafe location.",
            type: "trigger",
            priority: 2,
            requirements: {
              physicalHealth: {
                lt: 1,
              },
              age: {
                gt: 2,
              },
              tags: {
                and: [],
              },
            },
            selections: [
              {
                title: {
                  en: "I've received help. ",
                },
                effects: {
                  age: -1,
                  tags: {
                    add: [],
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
